/*eslint new-cap:0 */
export default class ViewModel {
}
